import React from 'react'
import './loader.css'

const Loader = ({ personalLogo }) => {
  return (
    <>
      {personalLogo ? (
        <>
       <div class="animation-container">
        <img class="logo" src="https://res.cloudinary.com/dtg40vnf7/image/upload/v1774353544/IMG_8609_vr6mid.jpg" alt="Aamantran Logo" />
    </div>
    </>
      ) : (
        <div className="center-logo">
          <div className="loader"></div>
        </div>
      )}
    </>
  )
}

export default Loader